/**
 *  @class
 *  @function ScrollingImagesMarquee
 *
 *  Provides a play/pause control for the scrolling-images marquee, and
 *  keeps the animation stopped by default when the visitor's OS is set
 *  to prefers-reduced-motion.
 */
if (!customElements.get('scrolling-images-marquee')) {
  class ScrollingImagesMarquee extends HTMLElement {
    constructor() {
      super();
      this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    connectedCallback() {
      // Guard against re-connects (e.g. theme-editor section reorders) so
      // listeners are only registered once.
      if (this.initialized) return;
      this.initialized = true;

      this.toggle = this.querySelector('.scrolling-images--pause-toggle');

      this.paused = this.reduceMotionQuery.matches;
      this.render();

      if (this.toggle) {
        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      }

      this.reduceMotionQuery.addEventListener('change', this.onReduceMotionChange.bind(this));
    }

    onToggleClick() {
      this.paused = !this.paused;
      this.render();
    }

    onReduceMotionChange(event) {
      this.paused = event.matches;
      this.render();
    }

    render() {
      this.classList.toggle('scrolling-images--paused', this.paused);

      if (this.toggle) {
        // Name-swapping control: the accessible name always describes what
        // pressing the button will do next (so no aria-pressed state).
        var label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;

        if (label) {
          this.toggle.setAttribute('aria-label', label);
        }
      }
    }
  }

  customElements.define('scrolling-images-marquee', ScrollingImagesMarquee);
}
